import { Hero } from '../components/Hero';
import { Reveal } from '../components/Reveal';
import { Link } from '../components/Link';

const teamProgram = [
  { label: 'Lunch', text: 'We beginnen met een lunch. Hier is ruimte voor gesprek en verbinding met elkaar.' },
  { label: 'Aanbidding', text: 'We willen Gods aanwezigheid opzoeken en Hem prijzen omdat Hij het zo waard is.' },
  { label: 'Onderwijs', text: 'Een gast of iemand van ons eigen team geeft ons onderwijs uit Gods woord.' },
  { label: 'Gebed', text: 'We gaan in kleine groepjes doorpraten en met elkaar bidden.' },
];

const SectionHead = ({
  eyebrow,
  titlePrefix,
  italicTail,
  dark = false,
}: {
  eyebrow: string;
  titlePrefix: string;
  italicTail: string;
  dark?: boolean;
}) => (
  <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12 md:mb-16">
    <div className="md:col-span-5">
      <span className={`eyebrow ${dark ? 'text-white/55' : 'text-[#0D0A00]/60'}`}>{eyebrow}</span>
    </div>
    <div className="md:col-span-7">
      <h2
        className={`text-[40px] md:text-[52px] font-medium tracking-[-0.03em] leading-[1.03] ${
          dark ? 'text-white' : 'text-[#0D0A00]'
        }`}
      >
        {titlePrefix}{' '}
        <span className={`font-serif-display italic font-normal ${dark ? 'text-[#F5B800]' : 'text-[#0D0A00]/70'}`}>
          {italicTail}
        </span>
      </h2>
    </div>
  </div>
);

export const OverOns = () => (
  <>
    <Hero
      title="Over ons"
      description="Wij zijn Restart: een sportcommunity waar iedereen welkom is. We verlangen ernaar om samen te groeien in geloof en te getuigen van Jezus in de dorpen."
      imageSrc="/images/team-totaal.jpg"
      overlay
      fullHeight
      eyebrow="Het verhaal achter Restart"
    />

    {/* Wie zijn wij */}
    <section className="py-28 md:py-36 px-6 sm:px-10 md:px-16 bg-white">
      <div className="container mx-auto max-w-6xl">
        <SectionHead eyebrow="Ons verhaal" titlePrefix="Wie zijn" italicTail="wij?" />
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5" />
          <div className="md:col-span-7 space-y-6 text-[17px] text-[#0D0A00]/70 leading-[1.7] max-w-[62ch]">
            <Reveal>
              <p>
                Wij zijn een enthousiaste groep jongeren uit allerlei verschillende kerken die meer van Jezus willen en Zijn liefde delen met anderen.
              </p>
            </Reveal>
            <Reveal>
              <p>
                In oktober 2023 zijn we begonnen met een team van vijf in Ten Boer. Inmiddels is ons team flink gegroeid en zijn we in januari 2025 begonnen met een team in Bedum. Maar dit alles is begonnen met gebed. We hebben zoveel van Gods werk mogen zien in de afgelopen tijd.
              </p>
            </Reveal>
            <Reveal>
              <p>
                Zou jij graag bij het team willen of hier meer van willen weten? Kom naar het veld toe en spreek ons aan. We willen graag met je meelopen in je geloof. Vanaf 14 jaar mag je meedraaien in ons team.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>

    {/* Ons verlangen */}
    <section className="py-28 md:py-36 px-6 sm:px-10 md:px-16 bg-[#FBFAF6]">
      <div className="container mx-auto max-w-6xl">
        <SectionHead eyebrow="Missie" titlePrefix="Ons" italicTail="verlangen." />
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="md:sticky md:top-28">
              <p className="font-serif-display italic text-[28px] md:text-[34px] text-[#0D0A00]/80 leading-[1.25] max-w-[18ch]">
                "Voor de Koning, amen."
              </p>
            </div>
          </div>
          <div className="md:col-span-7 space-y-6 text-[17px] text-[#0D0A00]/70 leading-[1.7] max-w-[62ch]">
            <Reveal>
              <p>
                We willen graag verbinding met het dorp en een veilige plek bieden voor de jeugd. Wij geloven dat sport verbindt en dat hebben we echt mogen zien. Tijdens het sporten en buiten het veld streven wij naar een positieve sfeer. Door elke zondag op het veld te zijn, leren wij de jongeren kennen en zij elkaar. Hierdoor raken ze betrokken bij elkaar en ontstaat er verbinding.
              </p>
            </Reveal>
            <Reveal>
              <p>
                Vanuit deze verbinding en het vertrouwen willen we iedereen die bij het veld komt graag iets meegeven van Jezus. We verlangen naar meer van Jezus in Ten Boer en Bedum. We hebben al veel mogen zien van Zijn werk door de sportcommunity's heen.
              </p>
            </Reveal>
            <Reveal>
              <p>
                We verlangen ernaar dat meer mensen Jezus zullen aannemen in hun leven. We willen graag getuigen en delen van Jezus Christus, van Zijn liefde en goedheid en dat Hij een levende God is.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>

    {/* Programma voor het team */}
    <section className="py-28 md:py-36 px-6 sm:px-10 md:px-16 bg-[#0D0A00] relative overflow-hidden">
      <div
        className="absolute -bottom-40 -right-40 w-[520px] h-[520px] rounded-full opacity-[0.07] blur-3xl pointer-events-none"
        style={{ background: '#F5B800' }}
      />
      <div className="container mx-auto max-w-6xl relative">
        <SectionHead eyebrow="Teamtijd" titlePrefix="Programma voor" italicTail="het team." dark />
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <p className="text-white/60 text-[16.5px] leading-[1.7] max-w-[40ch]">
              Voordat we naar het veld gaan wordt er eerst in het team geïnvesteerd. We geloven dat het belangrijk is om eerst gevoed te worden in ons geloof om daarna te kunnen dienen.
            </p>
          </div>
          <div className="md:col-span-7">
            <div className="flex flex-col divide-y divide-white/8">
              {teamProgram.map(({ label, text }, i) => (
                <div key={label} className="grid grid-cols-12 gap-4 py-6 first:pt-0 group">
                  <span className="col-span-3 md:col-span-2 text-[#F5B800]/70 font-mono text-[12px] tracking-wider pt-1">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <div className="col-span-9 md:col-span-10">
                    <h4 className="text-white text-[19px] font-medium tracking-[-0.015em] mb-1.5">{label}</h4>
                    <p className="text-white/55 text-[15px] leading-[1.65] max-w-[58ch]">{text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Team foto's */}
    <section className="py-28 md:py-36 px-6 sm:px-10 md:px-16">
      <div className="container mx-auto max-w-6xl">
        <SectionHead eyebrow="De mensen achter Restart" titlePrefix="Team" italicTail="Restart." />

        {/* Two equal-weight team photos, matching aspect ratio for a calm grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { src: '/images/team-tenboer.jpg', name: 'Team Ten Boer', est: 'EST. 2023' },
            { src: '/images/team-bedum.jpg', name: 'Team Bedum', est: 'EST. 2025' },
          ].map((t) => (
            <Reveal key={t.name}>
              <div className="group rounded-[20px] overflow-hidden border border-[#0D0A00]/8 bg-white">
                <div className="overflow-hidden aspect-[4/3]">
                  <img
                    src={t.src}
                    alt={t.name}
                    className="w-full h-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.04]"
                    loading="lazy"
                  />
                </div>
                <div className="px-7 py-6 flex items-baseline justify-between">
                  <h4 className="text-[#0D0A00] text-[20px] font-medium tracking-[-0.015em]">{t.name}</h4>
                  <span className="text-[#0D0A00]/40 font-mono text-[12px] tracking-wider">{t.est}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 flex justify-start">
          <Link
            href="/contact"
            className="btn-pill"
            style={{ background: '#0D0A00', color: '#fff' }}
          >
            Neem contact op met ons team
            <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
              <path d="M2 6H10M10 6L6 2M10 6L6 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  </>
);
